/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 19:46:00
 * @Description: Description
 */
'use strict';
angular.module("settingsModule",[
    "settingsRouterModule",
	"modifyDataModule",//修改资料
	"pgcModifyDataModule",//pgc修改资料
	"passwordSettingModule",//密码设置
	"settlementManagementModule",//结算管理
	"messageModule",//消息通知
	"contractChannelModule",//签约渠道
	"mainOperationInfoModule",//主体及运营信息
]).
controller('settingsCtrl', [function(){

}])